/* Saadgi Weavers — theme interactions */
(function () {
  "use strict";

  // ---- Mobile nav ----
  var toggle = document.querySelector("[data-nav-toggle]");
  var nav = document.querySelector("[data-nav]");
  var scrim = document.querySelector("[data-nav-scrim]");
  function closeNav() {
    if (nav) nav.classList.remove("is-open");
    if (scrim) scrim.classList.remove("is-open");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
    }
    document.body.style.overflow = "";
  }
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      if (scrim) scrim.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      document.body.style.overflow = open ? "hidden" : "";
    });
  }
  if (scrim) scrim.addEventListener("click", closeNav);
  if (nav) {
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeNav);
    });
  }
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeNav();
  });

  // ---- Carousel arrows ----
  document.querySelectorAll("[data-carousel]").forEach(function (root) {
    var track = root.querySelector("[data-track]");
    if (!track) return;
    root.querySelectorAll("[data-scroll]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dir = btn.getAttribute("data-scroll") === "next" ? 1 : -1;
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 14 : 300;
        track.scrollBy({ left: dir * step * 2, behavior: "smooth" });
      });
    });
  });

  // ---- Hero slider ----
  document.querySelectorAll("[data-hero-slider]").forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hero-slide]"));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-dot]"));
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var delay = reduce ? 0 : parseInt(root.getAttribute("data-autoplay"), 10) || 0;
    var i = 0;
    var timer = null;

    function show(n) {
      n = (n + slides.length) % slides.length;
      if (n === i) return;
      slides[i].classList.remove("is-active");
      if (dots[i]) { dots[i].classList.remove("is-active"); dots[i].removeAttribute("aria-selected"); }
      i = n;
      slides[i].classList.add("is-active");
      if (dots[i]) { dots[i].classList.add("is-active"); dots[i].setAttribute("aria-selected", "true"); }
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0) timer = setInterval(next, delay); }

    var nb = root.querySelector("[data-hero-next]");
    if (nb) nb.addEventListener("click", function () { next(); start(); });
    var pb = root.querySelector("[data-hero-prev]");
    if (pb) pb.addEventListener("click", function () { prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener("click", function () { show(parseInt(d.getAttribute("data-hero-dot"), 10)); start(); });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });

    var x0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null;
      start();
    }, { passive: true });

    start();
  });

  // ---- Product variant picker ----
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var optionSelects = Array.prototype.slice.call(form.querySelectorAll("[data-option-select]"));
    var idSelect = form.querySelector("[data-variant-select]");
    var dataEl = form.querySelector("[data-variant-data]");
    if (!optionSelects.length || !idSelect || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function currentVariant() {
      var chosen = optionSelects.map(function (s) { return s.value; });
      return variants.find(function (v) {
        return chosen.every(function (val, idx) { return v["option" + (idx + 1)] === val; });
      });
    }

    function sync() {
      var v = currentVariant();
      var addBtn = form.querySelector("[data-add-to-cart]");
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        return;
      }
      idSelect.value = String(v.id);
      idSelect.dispatchEvent(new Event("change", { bubbles: true })); // keep Buy It Now in sync
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
      // Price + SKU come pre-formatted from the server via the option label ("Title — ₹1,234.00")
      var opt = idSelect.querySelector('option[value="' + v.id + '"]');
      var priceEl = document.querySelector(".product-info .price");
      if (opt && priceEl) {
        var parts = opt.textContent.split("—");
        var price = parts[parts.length - 1].trim();
        if (price) priceEl.textContent = price;
      }
      var skuEl = document.querySelector("[data-sku]");
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      var productPage = form.closest(".product-page");
      var gallery = productPage ? productPage.querySelector("[data-gallery]") : null;
      var main = gallery ? gallery.querySelector("[data-gallery-main]") : document.querySelector("[data-gallery-main]");
      if (main && v.featured_image && v.featured_image.src) {
        if (gallery) {
          gallery.dispatchEvent(new CustomEvent("gallery:select-image", {
            detail: {
              imageId: v.featured_image.id,
              src: v.featured_image.src,
              alt: v.featured_image.alt
            }
          }));
        } else {
          main.src = v.featured_image.src;
        }
      }
    }

    optionSelects.forEach(function (s) { s.addEventListener("change", sync); });
  });

  // ---- Product gallery ----
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    var viewport = g.querySelector("[data-gallery-viewport]");
    var thumbs = Array.prototype.slice.call(g.querySelectorAll("[data-gallery-thumb]"));
    var previous = g.querySelector("[data-gallery-prev]");
    var next = g.querySelector("[data-gallery-next]");
    var status = g.querySelector("[data-gallery-status]");
    if (!main || !thumbs.length) return;

    var activeIndex = thumbs.findIndex(function (thumb) { return thumb.classList.contains("is-active"); });
    if (activeIndex < 0) activeIndex = 0;

    function show(index, options) {
      options = options || {};
      index = (index + thumbs.length) % thumbs.length;
      var selected = thumbs[index];
      var full = selected.getAttribute("data-full");
      var alt = selected.getAttribute("data-alt");

      if (options.updateSource !== false && full) {
        main.setAttribute("src", full);
        // A stale responsive source set would otherwise override the selected image.
        main.removeAttribute("srcset");
      }
      if (alt !== null) main.setAttribute("alt", alt);

      thumbs.forEach(function (thumb, thumbIndex) {
        var isCurrent = thumbIndex === index;
        thumb.classList.toggle("is-active", isCurrent);
        if (isCurrent) thumb.setAttribute("aria-current", "true");
        else thumb.removeAttribute("aria-current");
      });

      activeIndex = index;
      g.setAttribute("data-gallery-active-index", String(index));
      if (status) status.textContent = "Image " + (index + 1) + " of " + thumbs.length;

      if (options.scrollThumb && selected.scrollIntoView) {
        selected.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    }

    function showPrevious() { show(activeIndex - 1, { scrollThumb: true }); }
    function showNext() { show(activeIndex + 1, { scrollThumb: true }); }

    thumbs.forEach(function (t, index) {
      t.addEventListener("click", function () {
        show(index);
      });
    });

    if (previous) previous.addEventListener("click", showPrevious);
    if (next) next.addEventListener("click", showNext);

    if (viewport && thumbs.length > 1) {
      viewport.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          showPrevious();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          showNext();
        } else if (event.key === "Home") {
          event.preventDefault();
          show(0, { scrollThumb: true });
        } else if (event.key === "End") {
          event.preventDefault();
          show(thumbs.length - 1, { scrollThumb: true });
        }
      });

      var swipeStart = null;
      function completeSwipe(endX, endY) {
        if (!swipeStart) return;
        var dx = endX - swipeStart.x;
        var dy = endY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) < 44 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        if (dx < 0) showNext();
        else showPrevious();
      }

      if (window.PointerEvent) {
        viewport.addEventListener("pointerdown", function (event) {
          if (event.pointerType === "mouse" || event.isPrimary === false) return;
          swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        viewport.addEventListener("pointerup", function (event) {
          if (!swipeStart || swipeStart.id !== event.pointerId) return;
          completeSwipe(event.clientX, event.clientY);
        });
        viewport.addEventListener("pointercancel", function () { swipeStart = null; });
      } else {
        viewport.addEventListener("touchstart", function (event) {
          var touch = event.touches[0];
          if (touch) swipeStart = { x: touch.clientX, y: touch.clientY };
        }, { passive: true });
        viewport.addEventListener("touchend", function (event) {
          var touch = event.changedTouches[0];
          if (touch) completeSwipe(touch.clientX, touch.clientY);
        }, { passive: true });
        viewport.addEventListener("touchcancel", function () { swipeStart = null; }, { passive: true });
      }
    }

    g.addEventListener("gallery:select-image", function (event) {
      var detail = event.detail || {};
      var imageId = detail.imageId === undefined || detail.imageId === null ? "" : String(detail.imageId);
      var index = thumbs.findIndex(function (thumb) {
        return imageId && thumb.getAttribute("data-image-id") === imageId;
      });
      if (index >= 0) {
        show(index, { scrollThumb: true });
      } else if (detail.src) {
        main.setAttribute("src", detail.src);
        main.removeAttribute("srcset");
        if (detail.alt) main.setAttribute("alt", detail.alt);
      }
    });

    show(activeIndex, { updateSource: false });
  });

  // ---- Sort bar ----
  document.querySelectorAll("[data-sort-form]").forEach(function (form) {
    var select = form.querySelector("[data-sort-select]");
    if (!select) return;
    select.addEventListener("change", function () {
      // Sorting always restarts at page 1, which a fresh GET gives us for free.
      form.submit();
    });
  });

  // ---- Cart: compulsory phone number ----
  document.querySelectorAll("[data-cart-form]").forEach(function (form) {
    var input = form.querySelector("[data-phone-input]");
    if (!input) return;
    var error = form.querySelector("[data-phone-error]");
    var skipOnce = false;

    function digitCount(value) {
      return (value || "").replace(/\D/g, "").length;
    }
    function isValid() {
      var count = digitCount(input.value);
      return count >= 10 && count <= 15;
    }
    function setInvalid(invalid) {
      input.classList.toggle("is-invalid", invalid);
      input.setAttribute("aria-invalid", invalid ? "true" : "false");
      if (error) error.hidden = !invalid;
      input.setCustomValidity(invalid ? input.getAttribute("data-error-text") || "" : "");
    }

    input.setAttribute("data-error-text", error ? error.textContent.trim() : "");
    input.addEventListener("input", function () {
      if (isValid()) setInvalid(false);
    });

    // Quantity updates must not be blocked by the phone rule.
    form.querySelectorAll("[formnovalidate]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        skipOnce = true;
        window.setTimeout(function () { skipOnce = false; }, 0);
      });
    });

    form.addEventListener("submit", function (event) {
      var submitter = event.submitter;
      if (skipOnce || (submitter && submitter.hasAttribute("formnovalidate"))) {
        setInvalid(false);
        return;
      }
      if (isValid()) {
        setInvalid(false);
        return;
      }
      event.preventDefault();
      setInvalid(true);
      input.focus();
      if (input.scrollIntoView) input.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });

  // ---- Back to top ----
  var top = document.querySelector("[data-back-to-top]");
  if (top) {
    window.addEventListener("scroll", function () {
      top.classList.toggle("is-visible", window.scrollY > 500);
    }, { passive: true });
    top.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // ---- Review form: star picker ----
  document.querySelectorAll("[data-rating-input]").forEach(function (fieldset) {
    var row = fieldset.querySelector(".rating-input__stars");
    var radios = Array.prototype.slice.call(fieldset.querySelectorAll(".rating-input__radio"));
    if (!row || !radios.length) return;
    var readout = fieldset.querySelector("[data-rating-readout]");
    var error = fieldset.querySelector("[data-rating-error]");

    function checkedRadio() {
      return radios.filter(function (r) { return r.checked; })[0] || null;
    }

    // Taking over data-fill also switches off the CSS-only fallback in base.css,
    // so the two never disagree about which stars are lit.
    function paint(value) {
      row.setAttribute("data-fill", String(value || 0));
    }

    function describe(radio) {
      var label = fieldset.querySelector('label[for="' + radio.id + '"]');
      var spoken = label ? label.querySelector(".visually-hidden") : null;
      var word = radio.getAttribute("data-rating-word");
      var parts = [];
      if (spoken) parts.push(spoken.textContent.trim());
      if (word) parts.push(word);
      return parts.join(" · ");
    }

    function settle() {
      var radio = checkedRadio();
      paint(radio ? radio.value : 0);
      if (readout) readout.textContent = radio ? describe(radio) : "";
    }

    function clearError() {
      fieldset.classList.remove("is-invalid");
      if (error) error.hidden = true;
    }

    function showError() {
      fieldset.classList.add("is-invalid");
      if (error) error.hidden = false;
    }

    radios.forEach(function (radio) {
      var label = fieldset.querySelector('label[for="' + radio.id + '"]');
      if (label) {
        label.addEventListener("mouseenter", function () { paint(radio.value); });
      }
      // Only reflect a focused radio once it is actually chosen. Tabbing into an
      // untouched group lands on the first radio without selecting it, and lighting
      // that star up would claim a rating the customer never gave.
      radio.addEventListener("focus", function () { if (radio.checked) paint(radio.value); });
      radio.addEventListener("blur", settle);
      radio.addEventListener("change", function () {
        clearError();
        settle();
      });
      // The radios are visually replaced by the star labels, so let the inline
      // message do the talking instead of a browser bubble anchored to a 1px input.
      radio.addEventListener("invalid", function (event) {
        event.preventDefault();
        showError();
      });
    });

    row.addEventListener("mouseleave", settle);

    var form = fieldset.closest("form");
    if (form) {
      form.addEventListener("submit", function (event) {
        if (checkedRadio()) return;
        event.preventDefault();
        showError();
        radios[0].focus();
        if (fieldset.scrollIntoView) fieldset.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    settle();
  });

  // ---- Review form: open it as a modal ----
  var reviewDialog = document.querySelector("[data-review-dialog]");
  var reviewOutcome = document.querySelector("[data-review-success], [data-review-errors]");

  if (reviewDialog && typeof reviewDialog.showModal !== "function") {
    // No <dialog> support: drop the flag so the CSS leaves the form inline.
    reviewDialog.removeAttribute("data-modal");
    reviewDialog = null;
  }

  if (reviewDialog) {
    var lastReviewTrigger = null;

    function openReviewDialog(trigger) {
      lastReviewTrigger = trigger || null;
      if (!reviewDialog.open) reviewDialog.showModal();
      document.body.style.overflow = "hidden";
      reviewDialog.focus();
    }

    document.querySelectorAll("[data-review-open]").forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        openReviewDialog(trigger);
      });
    });

    reviewDialog.querySelectorAll("[data-review-close]").forEach(function (button) {
      button.addEventListener("click", function () { reviewDialog.close(); });
    });

    // Native dialogs do not close on a backdrop click; the backdrop registers as
    // a click on the dialog itself, outside any of its children.
    reviewDialog.addEventListener("click", function (event) {
      if (event.target !== reviewDialog) return;
      var box = reviewDialog.getBoundingClientRect();
      var inside = event.clientX >= box.left && event.clientX <= box.right &&
                   event.clientY >= box.top && event.clientY <= box.bottom;
      if (!inside) reviewDialog.close();
    });

    reviewDialog.addEventListener("close", function () {
      document.body.style.overflow = "";
      if (lastReviewTrigger) lastReviewTrigger.focus();
      lastReviewTrigger = null;
    });

    // Coming back from a submission, the thank-you (or the errors) live inside the
    // dialog, so it has to reopen or the customer sees no response at all.
    if (reviewOutcome) openReviewDialog(null);
  }

  // ---- Review form: announce the outcome of a submission ----
  if (reviewOutcome) {
    window.setTimeout(function () {
      if (reviewOutcome.hasAttribute("tabindex")) reviewOutcome.focus();
      else if (reviewOutcome.scrollIntoView) reviewOutcome.scrollIntoView({ block: "center" });
    }, 60);
  }

})();
